var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 43.96 43.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #ed1c24;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0,
    y: 0,
    width: 43.96,
    height: 43.96,
    rx: 21.98,
    ry: 21.98
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.52,14.03c-.8,0-1.45.65-1.45,1.45s.65,1.45,1.45,1.45,1.45-.65,1.45-1.45-.65-1.45-1.45-1.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.54,16.86c-5.88-3.38-11.95,2.69-8.57,8.57.39.69.97,1.26,1.66,1.66,5.88,3.38,11.96-2.69,8.57-8.57-.39-.69-.97-1.26-1.66-1.66ZM24.54,25.11c-3.92,2.53-8.12-1.67-5.59-5.59.17-.27.41-.5.68-.68,3.92-2.53,8.12,1.67,5.59,5.59-.17.27-.41.5-.68.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.38,34.34h-12.81c-3.29,0-5.96-2.67-5.96-5.96v-12.81c0-3.29,2.67-5.96,5.96-5.96h12.8c3.29,0,5.96,2.67,5.96,5.96v12.81c0,3.29-2.67,5.96-5.96,5.96ZM15.58,11.94c-2.01,0-3.63,1.63-3.63,3.63v12.81c0,2.01,1.63,3.63,3.63,3.63h12.8c2.01,0,3.63-1.63,3.63-3.63v-12.81c0-2.01-1.63-3.63-3.63-3.63h-12.81Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.b2ac04245ca24b88023f311d8e49e210.svg";
export { ForwardRef as ReactComponent };